<template>
  <h2
    class="title"
    tabindex="-1"
  >
    <slot />
  </h2>
</template>

<script>
export default {
  name: 'CTitleSmall'
}
</script>

<style lang="scss" scoped>
.title {
  outline: 0;
}
</style>
